module.exports = __webpack_public_path__ + "img/square.d0071439.png";